module.exports = __webpack_public_path__ + "static/media/savio4.b6c4045f.jpg";